const dayStyle = a => {
	const day = a.getDay() === 5 || a.getDay() === 6;
	return day ? "sday" : "";
};

const scales = [
	{ unit: "month", step: 1, format: "MMMM yyy" },
	{ unit: "day", step: 1, format: "d", css: dayStyle },
];

const tasks = [
	{
		id: 1,
		start: new Date(2024, 3, 2),
		end: new Date(2024, 3, 17),
		text: "Project planning",
		progress: 30,
		parent: 0,
		type: "summary",
		open: true,
		details: "Outline the project's scope and resources.",
	},
	{
		id: 10,
		start: new Date(2024, 3, 2),
		end: new Date(2024, 3, 5),
		text: "Marketing analysis",
		progress: 100,
		parent: 1,
		type: "task",
		details: "Analyze market trends and competitors.",
	},
	{
		id: 11,
		start: new Date(2024, 3, 5),
		end: new Date(2024, 3, 7),
		text: "Discussions",
		progress: 100,
		parent: 1,
		type: "task",
		details: "Team discussions on project strategies.",
	},
	{
		id: 110,
		start: new Date(2024, 3, 6),
		end: new Date(2024, 3, 9),
		text: "Initial design",
		progress: 60,
		parent: 11,
		type: "task",
		details: "Draft initial design concepts.",
	},
	{
		id: 111,
		start: new Date(2024, 3, 9),
		text: "Presentation",
		progress: 0,
		parent: 11,
		type: "milestone",
		details: "Present initial designs to stakeholders.",
	},
	{
		id: 112,
		start: new Date(2024, 3, 7),
		end: new Date(2024, 3, 12),
		text: "Prototyping",
		progress: 10,
		parent: 11,
		type: "task",
	},
	{
		id: 113,
		start: new Date(2024, 3, 8),
		end: new Date(2024, 3, 17),
		text: "User testing",
		progress: 0,
		parent: 11,
		type: "task",
	},

	{
		id: 12,
		start: new Date(2024, 3, 9),
		text: "Approval of strategy",
		progress: 100,
		parent: 1,
		type: "milestone",
	},

	{
		id: 2,
		start: new Date(2024, 3, 2),
		end: new Date(2024, 3, 15),
		text: "Project management",
		progress: 10,
		parent: 0,
		type: "summary",
		open: true,
	},
	{
		id: 20,
		start: new Date(2024, 3, 2),
		end: new Date(2024, 3, 5),
		text: "Resource planning",
		progress: 10,
		parent: 2,
		type: "task",
	},
	{
		id: 21,
		start: new Date(2024, 3, 5),
		end: new Date(2024, 3, 8),
		text: "Getting approval",
		progress: 10,
		parent: 2,
		type: "task",
	},
	{
		id: 22,
		start: new Date(2024, 3, 8),
		end: new Date(2024, 3, 11),
		text: "Team introduction",
		progress: 0,
		parent: 2,
		type: "task",
	},
	{
		id: 23,
		start: new Date(2024, 3, 11),
		end: new Date(2024, 3, 15),
		text: "Resource management",
		progress: 10,
		parent: 2,
		type: "task",
	},

	{
		id: 3,
		start: new Date(2024, 3, 9),
		end: new Date(2024, 4, 15),
		text: "Development",
		progress: 30,
		parent: 0,
		type: "summary",
		open: true,
	},
	{
		id: 30,
		start: new Date(2024, 3, 9),
		end: new Date(2024, 3, 15),
		text: "Prototyping",
		progress: 3,
		parent: 3,
		type: "task",
	},
	{
		id: 31,
		start: new Date(2024, 3, 15),
		end: new Date(2024, 3, 30),
		text: "Basic functionality",
		progress: 0,
		parent: 3,
		type: "task",
	},
	{
		id: 32,
		start: new Date(2024, 3, 30),
		end: new Date(2024, 4, 15),
		text: "Finalizing MVA",
		progress: 0,
		parent: 3,
		type: "task",
	},

	{
		id: 4,
		start: new Date(2024, 3, 9),
		end: new Date(2024, 4, 25),
		text: "Testing",
		progress: 3,
		parent: 0,
		type: "summary",
		open: true,
	},
	{
		id: 40,
		start: new Date(2024, 3, 9),
		end: new Date(2024, 3, 15),
		text: "Testing prototype",
		progress: 3,
		parent: 4,
		type: "task",
	},
	{
		id: 41,
		start: new Date(2024, 3, 15),
		end: new Date(2024, 3, 30),
		text: "Testing basic features",
		progress: 0,
		parent: 4,
		type: "task",
	},
	{
		id: 42,
		start: new Date(2024, 3, 30),
		end: new Date(2024, 4, 15),
		text: "Testing MVA",
		progress: 0,
		parent: 4,
		type: "task",
	},
	{
		id: 43,
		start: new Date(2024, 4, 15),
		end: new Date(2024, 4, 25),
		text: "Beta testing",
		progress: 0,
		parent: 4,
		type: "task",
		details:
			"Comprehensive testing of the beta version before the final release.",
	},

	{
		id: 5,
		start: new Date(2024, 4, 25),
		text: "Release 1.0.0",
		progress: 0,
		parent: 0,
		type: "milestone",
		details: "Official release of version 1.0.0 to the public.",
	},
];
const links = [
	{
		id: 1,
		source: 10,
		target: 11,
		type: "e2s",
	},
	{
		id: 2,
		source: 11,
		target: 12,
		type: "e2s",
	},
	{
		id: 3,
		source: 110,
		target: 111,
		type: "e2s",
	},
	{
		id: 4,
		source: 20,
		target: 21,
		type: "e2s",
	},
	{
		id: 5,
		source: 21,
		target: 22,
		type: "e2s",
	},
	{
		id: 6,
		source: 22,
		target: 23,
		type: "e2s",
	},
	{
		id: 7,
		source: 42,
		target: 5,
		type: "e2s",
	},
];

export function getData() {
	return { tasks, links, scales };
}
